<div *ngIf="myEFileDocs?.length > 0" class="container container-data-entry">
    <table class="table" style="width: 80%;">
        <tr style="font-size: smaller">
            <th *ngFor="let col of cols" style="width: 30%">
                {{col.header}}
            </th>
            <th></th>
        </tr>

        <tr *ngFor="let doc1 of myEFileDocs" style="font-size: small">
            <td>{{doc1.typeOfDocument[0]?.name}}</td>
            <td>{{doc1.description}}</td>
            <td><button id="viewBtn" type="button" class="btn btn-link btn-sm" (click)="viewEfileDoc(doc1.url)">View</button></td>
        </tr>
    </table>
</div>
